import { Bridge } from '@mc/mc-jsbridge'

export const promiseDefer = function () {
  var ret = {}
  const dfd = new Promise(function (resolve, reject) {
    ret.resolve = resolve
    ret.reject = reject
  })
  ret.promise = dfd
  return ret
}
/*
状态码
  SUCCESS 成功
  CANNOT_USE_QRCODE 无法使用二维码
  NO_AUTH 无权限
*/

// 二维码，条形码公共函数
let defer
export const scanQrCode = type => {
  defer = promiseDefer()
  Bridge.scanCode({ type, onlyFromCamera: true }, window.qrcodeResult)
  return defer.promise
}

window.qrcodeResult = data => {
  let res = {}
  try {
    res = JSON.parse(data)
  } catch (e) {
    defer.reject(data)
  }
  if (res.status === 'SUCCESS') {
    defer.resolve(res)
  } else {
    defer.reject(res)
  }
}
